import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCheckContractUnique } from '@/api/PMS/customerService/leaseContract/contractList';
import { fetchList as fetchTenantList } from '@/api/PMS/baseInformation/customer';
import { fetchList as fetchGarageList } from '@/api/PMS/baseInformation/garageoa';
import { fetchList as fetchParkingLotList } from '@/api/PMS/baseInformation/pakinglotoa';
import { fetchPropertyList } from '@/api/PMS/chargeManagement/chargingParameterSetting/bindingChargeStandard/bindingChargeStandard';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import selectHouse from './selectHouse';
import addTenant from './addTenant';
export default {
  components: {
    selectHouse: selectHouse,
    addTenant: addTenant
  },
  props: {
    isGeneratingBills: Boolean,
    showDialog: Boolean,
    isAddContract: Boolean,
    contractAddData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    needAddData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      itemKey: 0,
      uploadUrl: '',
      dialogImageUrl: '',
      downloadUrl: '',
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      rules: {
        areaGroupId: [{
          required: true,
          message: '请选择小区名称',
          trigger: 'change'
        }],
        customerId: [{
          required: true,
          message: '请选择租户',
          trigger: 'change'
        }],
        contractNo: [{
          required: true,
          message: '请输入合同编号',
          trigger: 'change'
        }],
        contractName: [{
          required: true,
          message: '请选择合同名称',
          trigger: 'change'
        }],
        beginDate: [{
          required: true,
          message: '请选择合同起始日期',
          trigger: 'change'
        }],
        endDate: [{
          required: true,
          message: '请选择合同结束日期',
          trigger: 'change'
        }]
      },
      loading: false,
      dialogVisible: false,
      dialogFormVisible: false,
      dialogTenantVisible: false,
      listObj: {},
      garageOption: [],
      files: [],
      options: [],
      fileList: [],
      addList: [],
      tenantOption: [],
      checkedTreesNodes: [],
      // 选中的房间树节点
      rentTypeOption: [{
        name: '租赁房间',
        value: 1
      }, {
        name: '租赁车位',
        value: 2
      }],
      delFileList: [],
      customerList: [],
      cascaderItem: [],
      houseList: [],
      parkingLotlist: [],
      dates: [],
      customerOption: [],
      multipleSelection: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    },
    childData: {
      handler: function handler(val) {
        this.$emit('transmitHouseContractData', {
          childData: this.childData,
          houseList: this.houseList,
          parkingLotlist: this.parkingLotlist
        });
      }
    },
    houseList: {
      handler: function handler(val) {
        this.$emit('transmitHouseContractData', {
          childData: this.childData,
          houseList: this.houseList
        });
      }
    },
    parkingLotlist: {
      handler: function handler(val) {
        this.$emit('transmitHouseContractData', {
          childData: this.childData,
          parkingLotlist: this.parkingLotlist
        });
      }
    },
    contractAddData: {
      handler: function handler(val, oldval) {
        this.receiveAddData();
      },
      deep: true
    },
    needAddData: function needAddData(n, o) {
      var _this = this;

      if (n) {
        if (this.list.length === 0) {
          this.list = this.list.concat(n);
        } else {
          n.forEach(function (item, i) {
            var isAdd = _this.list.every(function (val) {
              return val.chargeStandardId !== item.chargeStandardId;
            });

            if (isAdd) _this.list.push(item);
          });
        }
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.receiveAddData();
      this.loadMenuTree();

      if (this.isAddContract) {
        this.houseList = [];
        this.parkingLotlist = [];
        this.childData = {
          leaseType: 1
        };
        this.files = [];
      }
    },
    loadTenantOption: function loadTenantOption(areaGroupId) {
      var _this3 = this;

      fetchTenantList({
        id: areaGroupId
      }).then(function (res) {
        _this3.tenantOption = res.data.data;
      });
    },
    // 接收需要添加的数据
    receiveAddData: function receiveAddData() {
      var _this4 = this;

      if (Object.keys(this.contractAddData).length > 0) {
        this.childData = this.contractAddData.childData;
        this.loadTenantOption(this.childData.areaGroupId);

        if (this.contractAddData.childData.leaseType === 1) {
          this.houseList = this.contractAddData.houseList;
        } else {
          this.loadGarageOption(this.childData.areaGroupId);
          this.parkingLotlist = this.contractAddData.parkingLotlist;
          this.parkingLotlist.forEach(function (item, index) {
            _this4.loadParkingLotOption(item.garageId, index);
          });
        }

        console.log('接收数据', this.contractAddData);

        if (this.childData.fileVos) {
          this.files = this.childData.fileVos.map(function (item) {
            return {
              name: item.fileName,
              url: item.fileId
            };
          });
        }
      }
    },
    // 添加房间
    handleSelectRoom: function handleSelectRoom() {
      if (this.childData.areaGroupId) {
        this.dialogFormVisible = true;
        this.checkedTreesNodes = this.houseList.map(function (item) {
          return item.resourceId;
        });
      } else {
        this.$message({
          message: '请先选择小区名称',
          type: 'error',
          duration: 3000
        });
      }
    },
    handleAddParkingLot: function handleAddParkingLot() {
      if (this.childData.areaGroupId) {
        this.parkingLotlist.push({});
      } else {
        this.$message({
          message: '请先选择小区名称',
          type: 'error',
          duration: 3000
        });
      }
    },
    handleAreaChange: function handleAreaChange(areaGroupId) {
      this.houseList = [];
      this.parkingLotlist = [];
      this.tenantOption = [];

      if (areaGroupId) {
        this.loadTenantOption(areaGroupId);
        this.loadGarageOption(areaGroupId);
      }
    },
    handleGarageChange: function handleGarageChange(id, index) {
      this.$set(this.parkingLotlist[index], 'parkingLotId', '');
      this.parkingLotlist[index].parkingLotOption = [];
      this.parkingLotlist[index].customerName = '';
      this.parkingLotlist[index].resourceArea = '';
      this.parkingLotlist[index].resourceId = '';
      console.log(this.parkingLotlist[index], '.....');
      if (id) this.loadParkingLotOption(id, index);
    },
    handleParkingLotChange: function handleParkingLotChange(id, index) {
      var parkingLotlist = this.parkingLotlist.map(function (item) {
        return item.resourceId;
      });
      var parkingLotlistSort = parkingLotlist.sort();
      console.log(parkingLotlistSort, 'parkingLotlistSort', parkingLotlist);

      for (var i = 0; i < parkingLotlist.length; i++) {
        if (parkingLotlistSort[i] === parkingLotlistSort[i + 1]) {
          this.$message({
            message: '不能添加相同的车位',
            type: 'error',
            duration: 3000
          });
          this.parkingLotlist[index].resourceId = '';
          return;
        }
      }

      this.parkingLotlist[index].customerName = '';
      this.parkingLotlist[index].resourceArea = '';
      this.parkingLotlist[index].garageId = '';
      this.parkingLotlist[index].parkingLotId = '';
      this.parkingLotlist[index].resourceId = '';
      var parkingLotItem = this.parkingLotlist[index].parkingLotOption.find(function (item) {
        return item.parkingLotId === id;
      });

      if (parkingLotItem) {
        this.parkingLotlist[index].customerName = parkingLotItem.customerName;
        this.parkingLotlist[index].resourceArea = parkingLotItem.parkingArea;
        this.parkingLotlist[index].garageId = parkingLotItem.garageId;
        this.parkingLotlist[index].parkingLotId = parkingLotItem.parkingLotId;
        this.parkingLotlist[index].resourceCode = parkingLotItem.parkingCode;
        this.parkingLotlist[index].resourceId = parkingLotItem.parkingLotId;
      }
    },
    // 获取车库
    loadGarageOption: function loadGarageOption(id) {
      var _this5 = this;

      fetchGarageList({
        id: id,
        dataType: '0'
      }).then(function (res) {
        _this5.garageOption = res.data.data;
      });
    },
    // 获取车位
    loadParkingLotOption: function loadParkingLotOption(garageId, index) {
      var _this6 = this;

      fetchParkingLotList({
        garageId: garageId,
        hasCustomer: 0
      }).then(function (res) {
        // res.data.data.forEach( (item,i) => {
        //   this.$set(this.parkingLotlist[index].parkingLotOption,i,item)
        // })
        _this6.parkingLotlist[index].parkingLotOption = res.data.data; // row.btnDisabled = true;

        _this6.itemKey++; //调用倒计时方法 key 自动加一
        // this.timers = setTimeout(() => {
        //   // row.btnDisabled = false;
        //   this.itemKey++;
        // }, 10000);
        // this.$set(chewei, index, row)
        // this.$nextTick(() => {
        //   this.$refs['chewei'].doLayout()
        // })

        console.log(_this6.parkingLotlist[index].parkingLotOption, 'this.parkingLotlist[index].parkingLotOption', index);
      });
    },
    loadMenuTree: function loadMenuTree() {
      var _this7 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (res) {
        if (res.data.data) {
          _this7.options = res.data.data.map(function (item) {
            return {
              dicName: item.name,
              dicValue: item.id
            };
          });
        }
      });
    },
    handleBeginDate: function handleBeginDate(time) {
      var beginTime = new Date(time).getTime();
      var endTime = new Date(this.childData.endDate).getTime();

      if (time && this.childData.renewalDate) {
        var renewalDate = new Date(this.childData.renewalDate).getTime();

        if (beginTime < renewalDate) {
          this.$message({
            message: '续签合同起始日期不能早于上个合同的结束日期',
            type: 'warning'
          });
          this.$set(this.childData, 'beginDate', '');
        }
      }

      if (time && this.childData.endDate) {
        if (beginTime > endTime) {
          this.$message({
            message: '合同起始日期不能晚于合同结束日期',
            type: 'warning'
          });
          this.$set(this.childData, 'beginDate', '');
        }
      }
    },
    handleEndDate: function handleEndDate(time) {
      var beginTime = new Date(this.childData.beginDate).getTime();
      var endTime = new Date(time).getTime();

      if (time && this.childData.renewalDate) {
        var renewalDate = new Date(this.childData.renewalDate).getTime();

        if (endTime < renewalDate) {
          this.$message({
            message: '续签合同结束日期不能早于上个合同的结束日期',
            type: 'warning'
          });
          this.$set(this.childData, 'endTime', '');
        }
      }

      if (time && this.childData.beginDate) {
        if (endTime < beginTime) {
          this.$message({
            message: '合同结束日期不能早于合同起始日期',
            type: 'warning'
          });
          this.$set(this.childData, 'endDate', '');
        }
      }
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this8 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this8.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleHouseDelete: function handleHouseDelete(index) {
      this.houseList.splice(index, 1);
      this.Alert({
        alertType: 'delete'
      });
    },
    handleParkingLotDelete: function handleParkingLotDelete(index) {
      this.parkingLotlist.splice(index, 1);
      this.Alert({
        alertType: 'delete'
      });
    },
    handleNext: function handleNext() {
      var _this9 = this;

      var isThrough = false;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          // 检查合同名称唯一性
          fetchCheckContractUnique({
            contractName: _this9.childData.contractName,
            uniqueType: 1,
            contractId: _this9.childData.contractId
          }).then(function (res) {
            if (res.data.data) {
              _this9.Alert({
                alertType: 'valid',
                message: '合同名称不能重复'
              });

              isThrough = false;
              return;
            } else {
              // 检查合同编号唯一性
              fetchCheckContractUnique({
                contractNo: _this9.childData.contractNo,
                uniqueType: 2,
                contractId: _this9.childData.contractId
              }).then(function (res) {
                if (res.data.data) {
                  _this9.Alert({
                    alertType: 'valid',
                    message: '合同编号不能重复'
                  });

                  isThrough = false;
                  return;
                } else {
                  // 表单验证
                  if (_this9.childData.leaseType === 1) {
                    if (_this9.houseList.length < 1) {
                      _this9.Alert({
                        alertType: 'valid',
                        message: '租赁房产信息不能为空'
                      });

                      return false;
                    }

                    if (_this9.isGeneratingBills) {
                      _this9.$emit('jumpToSecond');
                    } else {
                      _this9.$emit('handCancle', 'houseAdd');
                    }

                    _this9.$emit('transmitHouseContractData', {
                      childData: _this9.childData,
                      houseList: _this9.houseList
                    });

                    isThrough = true;
                  } else if (_this9.childData.leaseType === 2) {
                    if (_this9.parkingLotlist.length < 1) {
                      _this9.Alert({
                        alertType: 'valid',
                        message: '租赁车位信息不能为空'
                      });

                      return false;
                    }

                    for (var i = 0; i < _this9.parkingLotlist.length; i++) {
                      if (!_this9.parkingLotlist[i].garageId) {
                        _this9.$message.error("\u7B2C".concat(i + 1, "\u6761\u8BB0\u5F55\u7684\u505C\u8F66\u573A\u4E0D\u80FD\u4E3A\u7A7A"));

                        return false;
                      } else if (!_this9.parkingLotlist[i].resourceId) {
                        _this9.$message.error("\u7B2C".concat(i + 1, "\u6761\u8BB0\u5F55\u7684\u8F66\u4F4D\u4E0D\u80FD\u4E3A\u7A7A"));

                        return false;
                      }
                    }

                    if (_this9.isGeneratingBills) {
                      _this9.$emit('jumpToSecond');
                    } else {
                      _this9.$emit('handCancle', 'parkingLotAdd');
                    }

                    _this9.$emit('transmitParkingLotContractData', {
                      childData: _this9.childData,
                      parkingLotlist: _this9.parkingLotlist
                    });

                    isThrough = true;
                  }
                }
              });
            }
          });
        } else {
          _this9.Alert({
            alertType: 'valid'
          });

          isThrough = false;
        }
      });
      return isThrough;
    },
    handleAddCharge: function handleAddCharge() {
      if (!this.childData.areaGroupId) {
        this.Alert({
          alertType: 'nodata',
          message: '请先选择小区名称'
        });
      } else {
        this.dialogTenantVisible = true;
      }
    },
    handleDeletes: function handleDeletes() {
      var chargeStandardIds = [];
      this.multipleSelection.forEach(function (row) {
        chargeStandardIds.push(row.chargeStandardId);
      });
      this.delete(chargeStandardIds);
    },
    delete: function _delete(chargeStandardIds) {
      var _this10 = this;

      if (chargeStandardIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          var _loop = function _loop(i) {
            chargeStandardIds.forEach(function (id) {
              if (_this10.list[i].chargeStandardId === id) {
                _this10.list.splice(i, 1);
              }

              _this10.Alert({
                alertType: 'delete'
              });
            });
          };

          for (var i = 0; i < _this10.list.length; i++) {
            _loop(i);
          }
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    receiveHouseData: function receiveHouseData(data) {
      var _this11 = this;

      fetchPropertyList({
        resourceIdAndFlag: data
      }).then(function (res) {
        if (res.data.code === 200) {
          _this11.houseList = res.data.data;

          _this11.houseList.forEach(function (item) {
            item.resourceArea = item.houseArea;
          });
        }
      });
      this.dialogFormVisible = false;
    },
    handSelectCancle: function handSelectCancle() {
      this.dialogFormVisible = false;
    },
    handleCancle: function handleCancle() {
      this.$emit('handCancle');
    },
    handTenantCancle: function handTenantCancle() {
      this.dialogTenantVisible = false;
      this.loadTenantOption(this.childData.areaGroupId);
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      if (response.code === 200) {
        // this.addList.push({ decorateId: this.keyValue, filePath: file.response.data[0].fileId, fileName: response.data[0].fileName, fileExt: this.judgeFileType(file.raw.type) })
        this.fileList.push({
          fileId: file.response.data[0].fileId
        });
        this.childData.fileVos = this.fileList;
      }
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handlePreview: function handlePreview(file) {
      console.log('file', file);

      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'doc' || extension === 'docx' || extension === 'xls' || extension === 'xlsx' || extension === 'pdf';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/png/word/excel/pdf 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this12 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this12.fileList.splice(index, 1);

          return;
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.filePath === currentUrl) {
          _this12.addList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};